import { render } from "./ScrollingPreviews.vue?vue&type=template&id=080d350c&scoped=true&lang=pug"
import script from "./ScrollingPreviews.vue?vue&type=script&lang=js"
export * from "./ScrollingPreviews.vue?vue&type=script&lang=js"

import "./ScrollingPreviews.vue?vue&type=style&index=0&id=080d350c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-080d350c"]])

export default __exports__